import { get } from 'lodash/fp';
import axios from 'axios';
import config from '../../helpers/config';
import withCancellation from '../withCancellation';

const siteMap = {
  3: 'BDC',
  11: 'THD',
};

const instance = axios.create({
  baseURL: `${config.mandiBaseUrl}/api`,
  withCredentials: true,
});

instance.interceptors.request.use(requestConfig => ({
  ...requestConfig,
  params: {
    ...requestConfig.params,
    siteCode: siteMap[get('globalConfig.siteId')(window)],
  },
}));

export default withCancellation(instance);
